import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'
import NotFound from '@/views/404'
import User from '@/views/SysMng/User/UserManage'
import Process from '@/views/SysMng/Process/ProcessManage'
import PubType from '@/views/SysMng/PubType/PubManage'
import Journal from '@/views/SysMng/Journal/JournalManage'
import Partial from '@/views/SysMng/Partial/PartialManage'
import Log from '@/views/SysMng/TransLog'
import autoCollation from '@/views/SysMng/AutoCollation'
import autoTypeset from '@/views/SysMng/AutoTypeset'
import JournalDataUpload from '@/views/SysMng/Data/DataManage'
import DataUploadInfo from '@/views/SysMng/Data/DataManageInfo'
import JournalDataAudit from '@/views/SysMng/Data/AuditManage'
import DataAuditInfo from '@/views/SysMng/Data/AuditManageInfo'
import ftp from '@/views/SysMng/Ftp/FtpManage'
import mail from '@/views/SysMng/Mail/MailManage'
import intro from '@/views/SysMng/Intro/Intro'
import operation from '@/views/SysMng/OperationLog'
import uploadType from '@/views/SysMng/uploadType/UploadTypeManage'
import processData from '@/views/SysMng/Data/ProcessDataManage'
import individualUpload from '@/views/SysMng/Data/IndividualUpload'
import individualDownload from '@/views/SysMng/Data/individualDownload'

Vue.use(Router)

/*
const router = new Router({ //静态路由，登录、404
  routes: [
    {
      path: '/login',
      name:'登录',
      hidden:true,
      component:Login
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound
    },
    {
      path: '/accountMng',
      component: Home,
      name: '账户管理',
      menuShow: true,
      leaf: false, 
      iconCls: 'el-icon-setting', // 图标样式class 
      meta:{
        title:'accountMng',
        roles:['admin']
      },
      children: [
        {path: '/SysMng/User/UserManage', component: User, name: '用户管理',menuShow: true, meta:{roles:['admin']}},
        {path: '/SysMng/Institution', component: Institution, name: '机构管理',menuShow: true, meta:{roles:['admin']}},
        {path: '/SysMng/Journal/JournalManage', component: Journal, name: '期刊管理', menuShow: true, meta:{roles:['admin']}},
        {path: '/SysMng/Ftp/FtpManage', component: ftp, name: 'FTP配置管理', menuShow: true, meta:{roles:['admin']}},
        {path: '/SysMng/Mail/MailManage', component: mail, name: 'Mail配置管理', menuShow: true, meta:{roles:['admin']}},
      ]
    },
    {
      path: '/sysMng',
      component: Home,
      name: '系统配置',
      menuShow: true,
      leaf: false, 
      iconCls: 'el-icon-setting', // 图标样式class
      meta:{
        title:'sysMng',
        roles:['admin']
      },
      children: [
        {path: '/sysMng/processMng', component: Process, name: '转换类型配置', menuShow: true, meta:{roles:['admin']}},
        {path: '/sysMng/pubTypeMng', component: PubType, name: '出版类型配置', menuShow: true, meta:{roles:['admin']}},
      ]
    },
    {
      path: '/resultMng',
      component: Home,
      name: '结果查看',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'el-icon-view', // 图标样式class
      meta:{
        title:'resultMng',
        roles:['admin','user']
      },
      children: [
        {path: '/resultMng/transLog', component: Log, name: '结果查看', menuShow: true, meta:{roles:['admin', 'user']}}
      ]
    },
    {
      path: '/intro',
      component: Home,
      name: '简介',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'el-icon-view', // 图标样式class
      meta:{
        title:'intro',
        roles:['admin','user']
      },
      children: [
        {path: '/intro', component: intro, name: '简介', menuShow: true, meta:{roles:['admin', 'user']}}
      ]
    }
  ]
});

export default router //默认静态路由

*/

export const constantRouterMap = [
  {
    path: '/login',
    name:'登录',
    hidden:true,
    component:Login
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFound
  },
]

export const asyncRouterMap = [
  {
    path: '/accountMng',
    component: Home,
    name: '账户管理',
    menuShow: true,
    leaf: false, 
    iconCls: 'el-icon-s-custom', // 图标样式class 
    meta:{
      title:'accountMng',
      roles:['admin']
    },
    children: [
      {path: '/SysMng/User/UserManage', component: User, name: '用户管理',menuShow: true, meta:{roles:['admin']}},
      //{path: '/SysMng/Institution', component: Institution, name: '机构管理',menuShow: true, meta:{roles:['admin']}},
      {path: '/SysMng/Journal/JournalManage', component: Journal, name: '期刊管理', menuShow: true, meta:{roles:['admin']}},
      
    ]
  },
  {
    path: '/sysMng',
    component: Home,
    name: '系统管理',
    menuShow: true,
    leaf: false, 
    iconCls: 'el-icon-setting', // 图标样式class
    meta:{
      title:'sysMng',
      roles:['admin']
    },
    children: [
      {path: '/sysMng/FtpManage', component: ftp, name: 'FTP配置管理', menuShow: true, meta:{roles:['admin']}},
      {path: '/sysMng/MailManage', component: mail, name: 'Mail配置管理', menuShow: true, meta:{roles:['admin']}},
    ]
  },
  {
    path: '/resultMng',
    component: Home,
    name: '信息管理',
    menuShow: true,
    leaf: false, // 只有一个节点
    iconCls: 'el-icon-s-claim', // 图标样式class
    meta:{
      title:'resultMng',
      roles:['admin','user','upload','audit','process', 'latex']
    },
    children: [
      {path: '/resultMng/transLog', component: Log, name: '转换结果查看', menuShow: true, meta:{roles:['admin', 'user']}},
      {path: '/resultMng/journalData', component: JournalDataUpload, name: '整期数据上传', menuShow: true, meta:{roles:['admin', 'upload','process']}},
      {path: '/resultMng/issueData', component: DataUploadInfo, name: '整期数据上传详情', menuShow: false, meta:{roles:['admin', 'upload','process']}},
      //{path: '/resultMng/individualDownload',component:individualDownload, name:'单篇数据处理',menuShow:true,meta:{roles:['admin','process']}},
      {path: '/resultMng/individualUpload', component: individualUpload, name: '单篇数据上传', menuShow: true, meta:{roles:['admin']}},
      {path: '/resultMng/processData', component:processData, name:'加工任务处理',menuShow:true,meta:{roles:['admin','process']}},
      {path: '/resultMng/journalDataAudit', component: JournalDataAudit, name: '期刊数据审核', menuShow: true, meta:{roles:['admin', 'audit']}},
      {path: '/resultMng/dataAuditInfo', component: DataAuditInfo, name: '数据审核详情', menuShow: false, meta:{roles:['admin', 'audit']}},
      {path: '/resultMng/operation', component: operation, name: '审计日志', menuShow: true, meta:{roles:['admin']}},
      //{path: '/resultMng/autoCollation', component: autoCollation, name: '转换任务', menuShow: true, meta:{roles:['admin', 'latex']}},
      {path: '/resultMng/autoTypeset', component: autoTypeset, name: 'word-xml转换', menuShow: true, meta:{roles:['admin', 'latex']}},
    ]
  },
  {
    path: '/developMng',
    component: Home,
    name: '开发管理',
    menuShow: true,
    leaf: false, // 只有一个节点
    iconCls: 'el-icon-s-data', // 图标样式class
    meta:{
      title:'developMng',
      roles:['admin','user']
    },
    children: [
      {path: '/developMng/processMng', component: Process, name: '转换类型配置', menuShow: true, meta:{roles:['admin']}},
      {path: '/developMng/pubTypeMng', component: PubType, name: '出版类型配置', menuShow: true, meta:{roles:['admin']}},
      {path: '/developMng/uploadTypeMng', component: uploadType, name: '上传转换类型配置', menuShow: true, meta:{roles:['admin']}},
    ]
  },
  {
    path: '/intro',
    component: Home,
    name: '简介',
    menuShow: true,
    leaf: true, // 只有一个节点
    iconCls: 'el-icon-view', // 图标样式class
    meta:{
      title:'intro',
      roles:['admin','user']
    },
    children: [
      {path: '/intro', component: intro, name: '简介', menuShow: true, meta:{roles:['admin']}}
    ]
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})







// WEBPACK FOOTER //
// ./src/router/index.js